// config.js
const config = {
  // reactServer: process.env.REACT_APP_SERVER,
  reactServer: process.env.REACT_APP_SERVER || "http://localhost:5001/",
  // reactServer: process.env.REACT_APP_SERVER || 'https://otap-wellcomhealth-b0etbfathpejh5cz.northeurope-01.azurewebsites.net/',
  // reactServer: process.env.REACT_APP_SERVER || 'https://live-wellcomhealth-g5cgbxgreegphnb2.northeurope-01.azurewebsites.net/',
};

export default config;
